(function($) {
$(function(){

  /*****
    Fancybox
    ---
    This is just sample code, to be extended
  *****/
  $().fancybox({
    selector : '.photo-lightbox, .blocks-gallery-item a, .wp-block-image a',
    hash: false,
    infobar: false,
    animationEffect: "zoom",
    transitionEffect: "slide",
    buttons: ["close"],
    protect: true
  });

});
})(jQuery);
